

interface Props extends React.LabelHTMLAttributes<HTMLLabelElement> {
    borderRightColor?: string;
    borderBottomColor?: string;
    borderBottomDashArray?: string;
}

export function LabelWithBorder({
    borderRightColor,
    borderBottomColor,
    borderBottomDashArray = 'none', // Default to no dashes (solid line)
    children,
    style,
    ...props
}: Props) {
    return (
        <label
            {...props}
            style={{
                ...style,
                position: 'relative',
                display: 'inline-block',
            }}
        >
            {children}

            {borderBottomColor && (
                <svg
                    style={{
                        position: 'absolute',
                        bottom: 0,
                        left: 0,
                        width: '100%',
                        height: '2px',
                    }}
                    xmlns='http://www.w3.org/2000/svg'
                >
                    <line
                        x1='0'
                        y1='1'
                        x2='100%'
                        y2='1'
                        stroke={borderBottomColor}
                        strokeWidth='2'
                        strokeDasharray={borderBottomDashArray}
                    />
                </svg>
            )}

            {borderRightColor && (
                <svg
                    style={{
                        position: 'absolute',
                        top: 0,
                        right: 5,
                        height: '100%',
                        width: '2px',
                    }}
                    xmlns='http://www.w3.org/2000/svg'
                >
                    <line
                        x1='1'
                        y1='0'
                        x2='1'
                        y2='100%'
                        stroke={borderRightColor}
                        strokeWidth='2'
                    />
                </svg>
            )}

        </label>
    );
}

